import styled from '@emotion/styled'
import theme from '../../constants/theme'
import { Container } from 'react-bootstrap'
export const FormWrapper = styled('div')(() => ({
  width: '100%',
  maxWidth: '860px',
  margin: '0 auto',
  padding: '24px 16px 40px',
}))

export const SectionCard = styled('div')(() => ({
  backgroundColor: theme.white,
  borderRadius: '16px',
  border: '1px solid #eef1f4',
  boxShadow: '0 1px 3px rgba(16,24,40,0.05), 0 1px 2px rgba(16,24,40,0.04)',
  padding: '24px',
  marginTop: '16px',
}))

export const SectionHeader = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  marginBottom: '16px',
  paddingBottom: '16px',
  borderBottom: '1px solid #eef1f4',
}))

export const IconBadge = styled('span')(() => ({
  width: '36px',
  height: '36px',
  borderRadius: '10px',
  backgroundColor: theme.talentinoLightBlueBackground,
  color: theme.brandColorOrange,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
}))

export const BannerCard = styled('div')(() => ({
  borderRadius: '16px',
  padding: '24px',
  marginTop: '16px',
  color: theme.white,
  background: `linear-gradient(135deg, ${theme.talentinoSpecialDarkBlue} 0%, ${theme.talentinoBlue} 100%)`,
}))

export const ProgressWrapper = styled(Container)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  backgroundColor: theme.white,
  borderRadius: '16px',
  border: '1px solid #eef1f4',
  boxShadow: '0 1px 3px rgba(16,24,40,0.05), 0 1px 2px rgba(16,24,40,0.04)',
  padding: '12px 24px',
  marginTop: '8px',
}))

export const ProgressTrack = styled('div')(() => ({
  height: '5px',
  width: '100%',
  backgroundColor: '#eef1f4',
  borderRadius: '99px',
  overflow: 'hidden',
}))

export const ProgressFill = styled('div')(({ progress }) => ({
  height: '100%',
  width: `${progress}%`,
  background: `linear-gradient(90deg, ${theme.brandColorLightOrange}, ${theme.brandColorOrange})`,
  borderRadius: '99px',
  transition: 'width 0.3s ease',
}))
